export default `
  query guest($customerId: ID!){
    guest(customerId: $customerId) {
      wishlist {
        items_count
      }
    }
  }
`;
